import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import classes from './Checkbox.scss'

const checkBox = ({ variant, label, changed, checked, disabled, groupClass, overrideClass }) => {
  let inputClasses = [classes.Checkbox]
  let labelClasses = [classes.InputLabel]
  let groupClasses = [classes.GroupCheckbox]
  let inputLabel = null
  if (variant === 'login') {
    inputClasses = [...inputClasses, classes.Login]
    labelClasses = [...labelClasses, classes.Login]
  } else if (variant === 'inputgroup') {
    groupClasses = [...groupClasses, classes.InputGroup]
  }

  if (groupClass && overrideClass) {
    groupClasses = groupClass
  } else if (groupClass) {
    groupClasses = [...groupClasses, groupClass]
  }

  if (label) {
    inputLabel = <label className={labelClasses.join(' ')}>{label}</label>
  }

  return (
    <div className={groupClasses.join(' ')}>
      <Checkbox
        type='checkbox'
        className={inputClasses.join(' ')}
        checked={checked}
        onChange={changed}
        disabled={disabled}
      />
      {inputLabel}
      {/* {validationText} */}
    </div>
  )
}

export default checkBox
